<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import axios from 'axios'
const isPro = process.env.NODE_ENV == 'production'
const isTest = process.env.NODE_ENV == 'integration'

export default {
  async created() {
    const requestUrlMap = {
      production: 'https://qc-proscheduler.prometric.com.cn/gentk.php',
      integration: 'https://qc-proscheduler.prometric.com.cn/gentk.php',
      development: '/jwtApi/gentk.php',
    }
    if (!isPro) {
      try {
        const res = await axios.get(requestUrlMap[process.env.NODE_ENV], {
          responseType: 'text', // 确保以文本形式解析响应
        })
        console.log(res)
        // 使用正则提取第一个 <script> 标签中的内容
        const scriptMatch = res.data.match(/<script[^>]*>([\s\S]*?)<\/script>/)
        if (scriptMatch && scriptMatch[1]) {
          const jsCode = scriptMatch[1]

          // 创建并插入 script 元素
          const script = document.createElement('script')
          script.textContent = jsCode
          document.body.appendChild(script)

          // 可选：执行后移除script标签
          script.remove();
        } else {
          console.warn('未找到有效的 <script> 标签')
        }
      } catch (error) {
        console.log('error', error)
      }
    }
  },
}
</script>

<style>
html,
body {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
}
#app {
  height: 100%;
  font-family: -apple-system, system-ui, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  font-size: 18px;
  color: #292b2c;
}
* {
  box-sizing: border-box;
}
.FlexClom {
  display: flex;
  align-items: center;
}
/* 数值方向多个剧中 */
.FlexMore {
  display: flex;
  justify-content: space-around;
  flex-direction: column;
}
/* 水平方向扩散分布 */
.FlexAround {
  display: flex;
  justify-content: space-around;
}
/* 水平方向剧中 */
.Flexroundcenter {
  display: flex;
  justify-content: space-around;
}
.flexcenter {
  display: flex;
  justify-content: center;
}
/* 新增 */
/* 横着 */
.D_A_A {
  display: flex;
  align-items: center;
  justify-content: space-around;
}
.D_A_B {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.D_A_B_zhong {
  display: flex;
  align-items: center;
  justify-content: space-between;
  align-items: center;
}
.D_J {
  display: flex;

  justify-content: space-between;
}
/* 竖直 */
.D_A_B_C {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
}
.D_A_B_D {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
}
/* 全局剧中 */
.D_center_flex {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
